module.exports = __webpack_public_path__ + "img/upload.e8d5506e.svg";